export { default, links, meta } from "/Users/heneilh/Projects/jsonhero-web/app/routes/privacy.mdx";